/**
 * Coerce a value of unknown shape to renderable text.
 *
 * DeliberationEvent fields (tool_result_summary, reasoning) are typed as
 * strings, but the backend has stored objects in them (e.g. {}), which crash
 * React when rendered directly as a child (minified React error #31 —
 * observed on the War Room page 2026-07-16 with "object with keys {}").
 *
 * Strings pass through (empty → null so `&&`-guards skip the block);
 * null/undefined and empty objects/arrays → null; numbers/booleans →
 * String(v); any other object → its JSON, so unexpected shapes stay visible
 * for debugging instead of crashing the page.
 */
export function safeText(v: unknown): string | null {
  if (typeof v === 'string') return v || null;
  if (v == null) return null;
  if (typeof v === 'number' || typeof v === 'boolean') return String(v);
  try {
    const s = JSON.stringify(v);
    return s === '{}' || s === '[]' || s === undefined ? null : s;
  } catch {
    return null;
  }
}
